// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"f500b528","453":"926f0775","687":"d9682b60"}[chunkId] + ".chunk.js";
};